import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { ApiService } from './api.service';

@Injectable()
export class ExportDataService extends ApiService {
  constructor(private http: Http) {
    super('api/export/', http);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/export-data.service.ts